"use client";

import { useRef, useState } from "react";
import { FaPlay } from "react-icons/fa6";
import { IoChevronBack } from "react-icons/io5";

const GuideSection = () => {
    const [started, setStarted] = useState(false);

    const videoRef = useRef<HTMLVideoElement>(null);
    const sliderRef = useRef<HTMLDivElement>(null);
    const cardRef = useRef<HTMLDivElement>(null);

    const scroll = (direction: "left" | "right") => {
        if (!sliderRef.current || !cardRef.current) return;

        const slider = sliderRef.current;
        const card = cardRef.current;

        const cardWidth = card.offsetWidth;

        // lấy gap thật của flex
        const gap = parseInt(window.getComputedStyle(slider).columnGap || "0", 10);

        const cardFullWidth = cardWidth + gap;

        // số card đang hiển thị trong viewport
        const visibleCount = Math.max(1, Math.floor(slider.offsetWidth / cardFullWidth));

        const scrollAmount = cardFullWidth * visibleCount;

        slider.scrollBy({
            left: direction === "left" ? -scrollAmount : scrollAmount,
            behavior: "smooth"
        });
    };

    const handlePlay = () => {
        if (started) return;
        setStarted(true);
        videoRef.current?.play();
    };

    return (
        <div className="relative h-[600px] tab:h-[680px] lap:h-[385px] desk:h-[472px] mt-20 tab:mt-15 overflow-hidden">
            <img
                src="/images/home/guide-section-bg.svg"
                alt=""
                className="absolute inset-0 h-full w-full object-cover object-center"
            />

            <div className="relative z-10 lap:w-[930px] desk:w-[1210px] mx-[17px] tab:mx-8 lap:mx-auto py-12 flex flex-col lap:flex-row gap-8 tab:gap-10 items-center">
                <div
                    onClick={handlePlay}
                    className="w-[368px] tab:w-[454px] desk:w-[582px] h-64 tab:h-[304px] desk:h-[376px] flex flex-col gap-4"
                >
                    <div className="text-xl leading-8 font-bold text-[#374151] text-center">
                        Video hướng dẫn sử dụng
                    </div>
                    <div className="w-full h-52 tab:h-64 desk:h-[328px] p-2.5 bg-white rounded-xl shadow relative cursor-pointer">
                        <video
                            ref={videoRef}
                            src="https://cdn.shopify.com/videos/c/o/v/09d4a46528324bb1b561b2206d2a77f7.mp4"
                            controls
                            playsInline
                            className="w-full h-full rounded-lg bg-gray-200"
                        />

                        {!started && (
                            <img
                                src="/images/home/instruct-img.png"
                                alt=""
                                className="w-[calc(100%-16px)] h-[calc(100%-16px)] rounded-xl absolute top-2 left-2"
                            />
                        )}
                        {!started && (
                            <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                                <FaPlay className="size-[55px]" color="white"/>
                            </div>
                        )}
                    </div>
                </div>

                <div className="max-lap:w-full lap:flex-1 flex flex-col gap-4">
                    <div className="rounded-xl border border-[#2196F333] text-[#1FAEEB] relative">
                        <img src="/images/home/parameter-bg.png" className="absolute w-full h-full" alt="" />
                        <div className="relative z-10 flex py-5 px-4">
                            <div className="w-1/2 text-center">
                                <div className="text-2xl desk:text-3xl font-bold">1000 +</div>
                                <div className="mt-2 font-medium">Tài xế tin dùng</div>
                            </div>
                            <div className="h-16 bg-white min-w-px" />
                            <div className="w-1/2 text-center">
                                <div className="text-2xl desk:text-3xl font-bold flex-center gap-3">
                                    4.9/ 5.0
                                    <img src="/images/home/star-app.svg" className="size-8" alt="" />
                                </div>
                                <div className="mt-2 font-medium line-clamp-1">Ứng dụng được đánh giá</div>
                            </div>
                        </div>
                    </div>

                    <div className="text-lg font-bold text-[#374151]">Tài xế nói gì?</div>

                    <div className="relative w-full">
                        <button
                            onClick={() => scroll("left")}
                            className="absolute cursor-pointer z-10 bg-white flex-center size-8 rounded-full border border-[#D1D5DB] -translate-x-5 top-1/2 -translate-y-1/2"
                        >
                            <IoChevronBack className="h-[21px] w-[18px]" color="#6B7280" />
                        </button>

                        <button
                            onClick={() => scroll("right")}
                            className="absolute cursor-pointer z-10 bg-white flex-center size-8 rounded-full border border-[#D1D5DB] right-0 translate-x-5 top-1/2 -translate-y-1/2 rotate-180"
                        >
                            <IoChevronBack className="h-[21px] w-[18px]" color="#6B7280" />
                        </button>

                        <div ref={sliderRef} className="flex gap-4 overflow-x-auto scroll-smooth scrollbar-x-hidden">
                            <div
                                ref={cardRef}
                                className="shrink-0 border border-[#2196F34D] bg-white rounded-xl flex items-center gap-3 px-[11px] py-[7px] w-full tab:w-[calc(50%-8px)]"
                            >
                                <img src="/images/home/driver-1.jpg" className="size-16 rounded-full" alt="" />
                                <div className="text-[#374151] flex-1">
                                    <div className="font-bold">Nguyễn Văn Hùng</div>
                                    <div className="mt-1 line-clamp-2 text-sm tab:text-base">
                                        Ứng dụng giúp tôi trả lời tin nhắn nhận đơn nhanh hơn rất nhiều.
                                    </div>
                                </div>
                            </div>
                            <div className="shrink-0 border border-[#2196F34D] bg-white rounded-xl flex items-center gap-3 px-[11px] py-[7px] w-full tab:w-[calc(50%-8px)]">
                                <img src="/images/home/driver-2.jpg" className="size-16 rounded-full" alt="" />
                                <div className="text-[#374151] flex-1">
                                    <div className="font-bold">Trần Minh Tuấn</div>
                                    <div className="mt-1 line-clamp-2 text-sm tab:text-base">
                                        Đơn vào là phản hồi liền, tiết kiệm thời gian và đỡ căng thẳng.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuideSection;
